import type { FlagKey } from "@/hooks/useFeatureFlags/flags";

export const GRP_PERSON_PROFILE_FLAG = "backoffice-grp-person-profile" satisfies FlagKey;

/** The FAA table reads consents for this many campaigns; the Add Authorization(s) picker uses the same limit. */
export const GRP_COMMISSION_CAMPAIGNS_LIMIT = 20;

/**
 * Campaign `editionYear` is the calendar year of the campaign's `startsAt` (UTC, as pga-backend
 * derives it); there is no separate program-year setting, so the current program year is the
 * current UTC calendar year.
 */
export const currentGrpProgramYear = () => new Date().getUTCFullYear();
